// extracted by mini-css-extract-plugin
export default {"mainContent":"dashboard_mainContent__NTJ7O","mainCollapsed":"dashboard_mainCollapsed__yJLxw"};